import { render, staticRenderFns } from "./projectBox.vue?vue&type=template&id=7587a6b4&scoped=true"
import script from "./projectBox.vue?vue&type=script&lang=js"
export * from "./projectBox.vue?vue&type=script&lang=js"
import style0 from "./projectBox.vue?vue&type=style&index=0&id=7587a6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7587a6b4",
  null
  
)

export default component.exports